export default {
  //get all SUPERADMIN_CHAPTERs
  GET_SUPERADMIN_CHAPTERS_REQUEST: "GET_SUPERADMIN_CHAPTERS_REQUEST",
  GET_SUPERADMIN_CHAPTERS_SUCCESS: "GET_SUPERADMIN_CHAPTERS_SUCCESS",
  GET_SUPERADMIN_CHAPTERS_FAIL: "GET_SUPERADMIN_CHAPTERS_FAIL",

  //edit SUPERADMIN_CHAPTERs
  EDIT_SUPERADMIN_CHAPTER_REQUEST: "EDIT_SUPERADMIN_CHAPTER_REQUEST",
  EDIT_SUPERADMIN_CHAPTER_SUCCESS: "EDIT_SUPERADMIN_CHAPTER_SUCCESS",
  EDIT_SUPERADMIN_CHAPTER_FAIL: "EDIT_SUPERADMIN_CHAPTER_FAIL",

  RESTRICT_SUPERADMIN_CHAPTER_REQUEST: "RESTRICT_SUPERADMIN_CHAPTER_REQUEST",
  RESTRICT_SUPERADMIN_CHAPTER_SUCCESS: "RESTRICT_SUPERADMIN_CHAPTER_SUCCESS",
  RESTRICT_SUPERADMIN_CHAPTER_FAIL: "RESTRICT_SUPERADMIN_CHAPTER_FAIL",

  ASQUARA_SUPERADMIN_CHAPTER_REQUEST: "ASQUARA_SUPERADMIN_CHAPTER_REQUEST",
  ASQUARA_SUPERADMIN_CHAPTER_SUCCESS: "ASQUARA_SUPERADMIN_CHAPTER_SUCCESS",
  ASQUARA_SUPERADMIN_CHAPTER_FAIL: "ASQUARA_SUPERADMIN_CHAPTER_FAIL",
  ACTIVE_SUPERADMIN_CHAPTER_REQUEST: "ACTIVE_SUPERADMIN_CHAPTER_REQUEST",
  ACTIVE_SUPERADMIN_CHAPTER_SUCCESS: "ACTIVE_SUPERADMIN_CHAPTER_SUCCESS",
  ACTIVE_SUPERADMIN_CHAPTER_FAIL: "ACTIVE_SUPERADMIN_CHAPTER_FAIL",

  //create SUPERADMIN_CHAPTER
  CREATE_SUPERADMIN_CHAPTER_REQUEST: "CREATE_SUPERADMIN_CHAPTER_REQUEST",
  CREATE_SUPERADMIN_CHAPTER_SUCCESS: "CREATE_SUPERADMIN_CHAPTER_SUCCESS",
  CREATE_SUPERADMIN_CHAPTER_FAIL: "CREATE_SUPERADMIN_CHAPTER_FAIL",

  DELETE_SUPERADMIN_CHAPTER_REQUEST: "DELETE_SUPERADMIN_CHAPTER_REQUEST",
  DELETE_SUPERADMIN_CHAPTER_SUCCESS: "DELETE_SUPERADMIN_CHAPTER_SUCCESS",
  DELETE_SUPERADMIN_CHAPTER_FAIL: "DELETE_SUPERADMIN_CHAPTER_FAIL",

  GET_SUPERADMIN_CHAPTER_REQUEST: "GET_SUPERADMIN_CHAPTER_REQUEST",
  GET_SUPERADMIN_CHAPTER_SUCCESS: "GET_SUPERADMIN_CHAPTER_SUCCESS",
  GET_SUPERADMIN_CHAPTER_FAIL: "GET_SUPERADMIN_CHAPTER_FAIL",

  //loading
  ADD_SUPERADMIN_CHAPTERS_LOADING: "ADD_SUPERADMIN_CHAPTERS_LOADING",
};
